export default __webpack_public_path__ + "b10e7a6e913ca664cbdcb17894f9b419.ttf";